// Internationalization strings - FR / EN
export const translations = {
  fr: {
    // Nav
    nav_home: "Accueil",
    nav_shop: "Boutique",
    nav_lookbook: "Lookbook",
    nav_about: "À propos",
    nav_contact: "Contact",
    nav_cart: "Panier",

    // Hero
    hero_eyebrow: "COLLECTION FOOTBALL",
    hero_title_1: "L'Équipement",
    hero_title_2: "des Champions",
    hero_subtitle:
      "Maillots, crampons, ballons et accessoires premium. Conçus pour les footballeurs guinéens qui visent l'excellence.",
    hero_cta_shop: "Voir la boutique",
    hero_cta_lookbook: "Lookbook",

    // Sections
    featured_eyebrow: "PIÈCES VEDETTES",
    featured_title: "L'essentiel Braf_Zak",
    categories_title: "Toutes les catégories",
    story_eyebrow: "NOTRE HISTOIRE",
    story_title: "Née en Guinée, portée partout.",
    story_body:
      "Braf_Zak est plus qu'une marque : c'est l'incarnation de la passion guinéenne pour le football. Chaque maillot, chaque crampon est conçu pour les joueurs qui refusent de jouer ordinaire.",
    story_cta: "Découvrir notre histoire",

    // Shop
    shop_title: "Boutique",
    shop_subtitle: "Tout l'équipement pour briller sur le terrain",
    filter_all: "Tout",

    // Product
    product_size: "Taille",
    product_color: "Couleur",
    product_quantity: "Quantité",
    product_add_to_cart: "Ajouter au panier",
    product_order_whatsapp: "Commander via WhatsApp",
    product_description: "Description",
    product_in_stock: "En stock",
    product_out_of_stock: "Rupture de stock",
    product_back: "← Retour",

    // Cart
    cart_title: "Mon panier",
    cart_empty: "Ton panier est vide",
    cart_empty_cta: "Découvrir la boutique",
    cart_subtotal: "Sous-total",
    cart_total: "Total",
    cart_checkout: "Commander via WhatsApp",
    cart_checkout_hint: "Tu seras redirigé vers WhatsApp avec ta commande pré-remplie.",
    cart_remove: "Retirer",
    cart_customer_name: "Ton nom complet",
    cart_customer_phone: "Ton numéro WhatsApp (ex: +224 6XX XX XX XX)",
    cart_customer_required: "Merci d'indiquer ton nom et ton numéro WhatsApp pour qu'on puisse te rappeler.",
    cart_customer_section: "Tes coordonnées",

    // Lookbook
    lookbook_eyebrow: "LOOKBOOK 2026",
    lookbook_title: "Élégance sur le terrain.",
    lookbook_subtitle: "Inspirations, mises en situation, esprit Braf_Zak.",

    // About
    about_eyebrow: "À PROPOS DE BRAF_ZAK",
    about_title: "Une marque, une passion, un drapeau.",
    about_body_1:
      "Né à Conakry, Braf_Zak équipe les footballeurs ambitieux à travers la Guinée et au-delà. Notre mission : offrir un équipement de qualité internationale, accessible, à l'esthétique unique blanc-noir-or.",
    about_body_2:
      "Nous travaillons avec des tissus respirants premium, des semelles testées sur les terrains africains, et un design pensé par et pour les passionnés du ballon rond.",
    about_pillar_1_title: "Qualité Pro",
    about_pillar_1_body: "Matériaux premium, finitions soignées, durabilité sur tous terrains.",
    about_pillar_2_title: "Esprit Guinée",
    about_pillar_2_body: "Fièrement basés à Conakry, fiers de représenter le talent guinéen.",
    about_pillar_3_title: "Style Or",
    about_pillar_3_body: "Une signature visuelle reconnaissable entre mille : blanc, noir, or.",

    // Contact
    contact_eyebrow: "ON DISCUTE ?",
    contact_title: "Contacte-nous",
    contact_subtitle:
      "Question, demande sur mesure, partenariat club ou commande en gros — écris-nous.",
    contact_name: "Nom complet",
    contact_email: "Email",
    contact_phone: "Téléphone (optionnel)",
    contact_message: "Message",
    contact_send: "Envoyer le message",
    contact_sent: "Message envoyé ! On te répond vite.",
    contact_error: "Une erreur est survenue. Réessaie.",
    contact_address: "Adresse",
    contact_address_value: "Conakry, République de Guinée",
    contact_phone_label: "Téléphone / WhatsApp",
    contact_email_label: "Email",

    // Newsletter
    newsletter_title: "Reste à l'écoute",
    newsletter_subtitle: "Nouvelles collections, drops limités, événements.",
    newsletter_placeholder: "Ton email",
    newsletter_cta: "S'inscrire",
    newsletter_thanks: "Merci ! Inscription confirmée.",

    // Footer
    footer_tagline: "L'équipement des champions.",
    footer_rights: "Tous droits réservés.",
    footer_links: "Navigation",
    footer_social: "Suis-nous",

    // Currency / common
    currency: "Fg",
    qty: "Qté",
    free_shipping: "Livraison Conakry incluse",
    secure_order: "Commande sécurisée WhatsApp",
    pay_on_delivery: "Paiement à la livraison",
  },
  en: {
    nav_home: "Home",
    nav_shop: "Shop",
    nav_lookbook: "Lookbook",
    nav_about: "About",
    nav_contact: "Contact",
    nav_cart: "Cart",

    hero_eyebrow: "FOOTBALL COLLECTION",
    hero_title_1: "Gear of",
    hero_title_2: "Champions",
    hero_subtitle:
      "Premium jerseys, cleats, balls and accessories. Designed for Guinean footballers chasing excellence.",
    hero_cta_shop: "Shop now",
    hero_cta_lookbook: "Lookbook",

    featured_eyebrow: "FEATURED PIECES",
    featured_title: "Braf_Zak Essentials",
    categories_title: "All categories",
    story_eyebrow: "OUR STORY",
    story_title: "Born in Guinea, worn everywhere.",
    story_body:
      "Braf_Zak is more than a brand: it embodies Guinean passion for football. Every jersey, every cleat is built for players who refuse the ordinary.",
    story_cta: "Discover our story",

    shop_title: "Shop",
    shop_subtitle: "Everything you need to shine on the pitch",
    filter_all: "All",

    product_size: "Size",
    product_color: "Color",
    product_quantity: "Quantity",
    product_add_to_cart: "Add to cart",
    product_order_whatsapp: "Order via WhatsApp",
    product_description: "Description",
    product_in_stock: "In stock",
    product_out_of_stock: "Out of stock",
    product_back: "← Back",

    cart_title: "My cart",
    cart_empty: "Your cart is empty",
    cart_empty_cta: "Browse the shop",
    cart_subtotal: "Subtotal",
    cart_total: "Total",
    cart_checkout: "Checkout via WhatsApp",
    cart_checkout_hint: "You'll be redirected to WhatsApp with your order pre-filled.",
    cart_remove: "Remove",
    cart_customer_name: "Your full name",
    cart_customer_phone: "Your WhatsApp number (e.g. +224 6XX XX XX XX)",
    cart_customer_required: "Please enter your name and WhatsApp number so we can reach you.",
    cart_customer_section: "Your contact details",

    lookbook_eyebrow: "LOOKBOOK 2026",
    lookbook_title: "Elegance on the pitch.",
    lookbook_subtitle: "Inspirations, situations, the Braf_Zak spirit.",

    about_eyebrow: "ABOUT BRAF_ZAK",
    about_title: "One brand, one passion, one flag.",
    about_body_1:
      "Born in Conakry, Braf_Zak equips ambitious footballers across Guinea and beyond. Our mission: world-class equipment at fair prices, with a signature white-black-gold aesthetic.",
    about_body_2:
      "We use premium breathable fabrics, soles tested on African pitches, and designs crafted by and for football lovers.",
    about_pillar_1_title: "Pro Quality",
    about_pillar_1_body: "Premium materials, refined finishes, durability on every pitch.",
    about_pillar_2_title: "Guinean Spirit",
    about_pillar_2_body: "Proudly based in Conakry, proudly representing Guinean talent.",
    about_pillar_3_title: "Gold Style",
    about_pillar_3_body: "A signature look you'll spot anywhere: white, black, gold.",

    contact_eyebrow: "LET'S TALK",
    contact_title: "Contact us",
    contact_subtitle:
      "Question, custom request, club partnership or bulk order — drop us a line.",
    contact_name: "Full name",
    contact_email: "Email",
    contact_phone: "Phone (optional)",
    contact_message: "Message",
    contact_send: "Send message",
    contact_sent: "Message sent! We'll reply soon.",
    contact_error: "Something went wrong. Try again.",
    contact_address: "Address",
    contact_address_value: "Conakry, Republic of Guinea",
    contact_phone_label: "Phone / WhatsApp",
    contact_email_label: "Email",

    newsletter_title: "Stay in the loop",
    newsletter_subtitle: "New drops, limited releases, events.",
    newsletter_placeholder: "Your email",
    newsletter_cta: "Subscribe",
    newsletter_thanks: "Thanks! Subscription confirmed.",

    footer_tagline: "Gear of champions.",
    footer_rights: "All rights reserved.",
    footer_links: "Navigation",
    footer_social: "Follow us",

    currency: "Fg",
    qty: "Qty",
    free_shipping: "Free Conakry delivery",
    secure_order: "Secure WhatsApp checkout",
    pay_on_delivery: "Pay on delivery",
  },
};

export const formatPrice = (gnf, lang = "fr") => {
  const formatted = new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-US").format(gnf);
  return `${formatted} Fg`;
};

export const CATEGORY_LABELS = {
  all: { fr: "Tout", en: "All" },
  jerseys: { fr: "Maillots", en: "Jerseys" },
  jerseys_countries: { fr: "Maillots des pays", en: "Country Jerseys" },
  jerseys_clubs: { fr: "Maillots des clubs", en: "Club Jerseys" },
  jerseys_neutral: { fr: "Maillot sans club & tenue de parade", en: "Plain Jerseys & Parade Wear" },
  cleats: { fr: "Crampons", en: "Cleats" },
  shoes: { fr: "Basket & claquettes", en: "Sneakers & Slides" },
  training: { fr: "Matériel d'entraînement", en: "Training Gear" },
  balls: { fr: "Ballons", en: "Balls" },
  gloves: { fr: "Gants", en: "Gloves" },
  socks: { fr: "Chaussettes", en: "Socks" },
  shinguards: { fr: "Protège-tibias", en: "Shin Guards" },
  accessories: { fr: "Accessoires & matériel d'entraînement", en: "Accessories & Training Gear" },
};

// Brand contact
export const BRAND = {
  whatsapp: "224620863124", // primary WhatsApp (intl format without +)
  whatsapp_alt: "224612507807", // secondary
  whatsapp_alt2: "224611365890", // tertiary
  instagram: "https://www.instagram.com/brafzak.shop",
  tiktok: "https://www.tiktok.com/@braf_zak.shop",
  facebook: "https://www.facebook.com/Brafzak.shop",
  snapchat: "https://snapchat.com/add/brafzak.shop",
  email: "brafzak55@gmail.com",
  phone: "+224 620 86 31 24",
  phone_alt: "+224 612 50 78 07",
  phone_alt2: "+224 611 36 58 90",
};
